import { Pipe, PipeTransform } from '@angular/core';
import { KnaufPalettes } from './knauf-palettes.enum';

@Pipe({
  name: 'palette'
})
export class PalettePipe implements PipeTransform {

  transform(value: KnaufPalettes, args?: any): string {
    switch (value) {
      case KnaufPalettes.MiejskiSzyk: return "Miejski szyk";
      case KnaufPalettes.KlasycznaElegancja: return "Klasyczna elegancja";
      case KnaufPalettes.SwiatoweInspiracje: return "Światowe inspiracje";
      case KnaufPalettes.WZgodzieZNatura: return "W zgodzie z naturą";
      case KnaufPalettes.invalid: return "invalid";
    }
  }

}
